import {
  AbstractAuthConfigService,
  IAuthConfig,
  OidcProvider,
} from '@gyselroth/angular-auth';
import { inject, Injectable } from '@angular/core';

import { OrganizationConfigService } from '../../organization/services/organizationConfig.service';
import {
  basicScopes,
  grAPIScopes,
  m2oAPIScopes,
  mailScopes,
  organizationConfigs,
  teamsScopes,
} from '../../organization/organization.config';
import { HelperService } from '../../helper/services/helper.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class AuthConfigService extends AbstractAuthConfigService {
  constructor() {
    super();
  }
  private _organizationConfigService = inject(OrganizationConfigService);
  private helperService = inject(HelperService);

  protected _config: IAuthConfig = {
    loginPath: 'login',
    allowAutoLogin: true,
    memoryStorage: true,
    isAuthorizedUser: async (_, __, user) => {
      const { loginType, mailEnding, shortName } =
        this._organizationConfigService.organization;

      if (!user) {
        return false;
      }

      if (loginType === 'azure') {
        const emailDomain =
          this.helperService.getEmailDomainFromPreferredUsername(
            user.preferred_username
          );

        return !!emailDomain && mailEnding.includes(emailDomain);
      }

      return !!user.organization && shortName === user.organization;
    },
    chooseProvider: async () => ({
      oidcProvider: this.loadProviderConfig(),
    }),
  };

  private loadProviderConfig(): OidcProvider {
    const organization = organizationConfigs.find(organization =>
      organization.urls.includes(window.location.origin)
    );

    // Basic AAI login provider information
    let authConfig: OidcProvider = {
      issuer: environment.oidcConfig.issuer,
      clientId: environment.oidcConfig.clientId,
      scope: 'openid profile email intranet offline_access',
      redirectUri: location.origin + '/login',
    };

    // These scopes are needed for every organization that is using azure for login
    let defaultAzureScopes: string[] = [...basicScopes, ...m2oAPIScopes];

    switch (organization?.shortName) {
      case 'gr':
        const grScopes = [...defaultAzureScopes, ...mailScopes, ...teamsScopes];

        authConfig = {
          issuer: 'https://login.microsoftonline.com/organizations/v2.0',
          clientId: 'd0349e9f-7609-43f3-beee-6cf2ac3ccccb',
          scope: grScopes.join(' '),
          redirectUri: location.origin + '/login',
          additionalConsentScopes: grAPIScopes.join(' '),
        };
        break;

      case 'kst':
        const kstScopes = [
          ...defaultAzureScopes,
          ...mailScopes,
          ...teamsScopes,
        ];

        authConfig = {
          issuer: 'https://login.microsoftonline.com/organizations/v2.0',
          clientId: 'd0349e9f-7609-43f3-beee-6cf2ac3ccccb',
          scope: kstScopes.join(' '),
          redirectUri: location.origin + '/login',
          additionalConsentScopes: grAPIScopes.join(' '),
        };
        break;
    }

    return authConfig;
  }
}
